import styled from 'styled-components';
import { TimePicker, DatePicker } from 'antd';

export const DamTitle = styled.h3`
  margin-top: 20px;
  font-size: 36px;
  margin-bottom: 0;
  font-family: 'quarkbold';
  color: #666;
`;

export const DivToStyle = styled.div`
  margin-left: 10px;
`;

export const DatePickerStyle = styled(DatePicker)`
  margin-left: 10px;
  width: 100%;
`;

export const TimePickerStyle = styled(TimePicker)`
  margin-left: 10px;
`;

export const FlexBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'flex-start'};
  ${(props) => props.itemsAlign && `align-items: ${props.itemsAlign}`};
  ${(props) => props.width && `width: ${props.width}`};
`;

export const RetrieveBtn = FlexBox.extend`
  padding-top: 10px;
`;

export const TimeSelector = FlexBox.extend`
  padding-top: 20px;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./resources/assets/js/components/PressureFilters/style.js